import crudHandlers from './_crud'

export default (state, action) => {
	const { type } = action
	switch (type) {
		case 'LOAD_USER_DOCUMENT_GROUP':
			return {
				...state,
				user_document_groups: action.response,
			}

		default:
			state = crudHandlers(state, action, 'document_group')

			return state
	}
}
